'use strict';

var _ = require('lodash');
var Validate = require('./Validate');

module.exports = {
  buildResourceDefinition: buildResourceDefinition,
  formatDefinition: formatDefinition
};

/**
 * Builds a `resource defintion object` to be passed to `DS.defineResource`
 * It takes a parametized resource definition and replaces all the placeholders with their
 * respective values. Also adds the `hooks`, `computed` properties, and `modelMethods` if available
 * 
 * @param  {Object} options parametize resource definition
 * @return {Object} formatted resource definition
 */
function buildResourceDefinition (options) {
  var definition = options.definition;
  var format = definition.format;
  var params = _.defaults(definition.params || {}, {
    name: options.name,
    basePath: options.apiBaseUri
  });

  var schema = format.schema;

  // temporarily remove schema... 
  // causes circular structure error
  delete (format.schema);

  var def = _(formatDefinition(format, params))
  .extend(options.hooks || {})
  .extend({computed: options.computed || {}})
  .extend({methods: options.modelMethods || {}})
  .value();

  if (schema) {
    def.schema = schema;
  }

  return def;
}

/**
 * Takes a url definition string or definition object and replaces placeholders with actual
 * parameters. Placeholders should follow the format ":key", where key corresponds to a
 * params attribute.
 * 
 * @param  {Object|String} definition
 * @param  {Object} params
 * @return {Object|String} modified definition
 */
function formatDefinition (definition, params) {
  var stringified = false;
  
  if (typeof definition === 'object') {
    definition = JSON.stringify(definition);
    stringified = true;
  }

  // extract placeholders
  var placeholders = extractPlaceholders(definition);

  // replace all placeholders
  _.forEach(placeholders, function (placeholder) {
    var key = placeholder.replace(':', '');

    // ensure all keys exist before attempting to replace them
    Validate.exists(params, key);
    definition = definition.replace(placeholder, params[key]);
  });

  if (stringified) {
    definition = JSON.parse(definition);
  }

  return definition;
}

function extractPlaceholders (string) {
  
  var placeholders = string.match(/:([A-Za-z_-]+)/g);

  // remove null, true, false, undefined
  var skip = ['null', 'true', 'false', 'undefined'];

  return _.filter(placeholders, function (placeholder) {
    placeholder = placeholder.replace(':', '');
    return !~skip.indexOf(placeholder);
  });
}


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/core/Util.js